









































import Vue from 'vue'
import { IDevice, IVW } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin, elementWidth } from '@/mixins'
import easyapi from '@/easyapi'
import { extender_vendor_t } from '@/types/api'
import InteractiveVw from '@/components/InteractiveVw.vue'
import TxDragRow from '@/components/TxDragRow.vue'
import { deepCopy } from '@/utils'
import SaveCancelDiscard from '@/components/dialogs/SaveCancelDiscard.vue'
import { isEqual } from 'lodash'

export default mixins(vwDialogMixin, elementWidth).extend({
  components: {
    InteractiveVw,
    TxDragRow,
    SaveCancelDiscard,
  },
  data (): {
    nameFilterStr: string | null
    copiedVw: IVW | null,
    draggingTx: IDevice | null,
    hoveringTx: IDevice | null,
    draggerBlinking: boolean,
    showSaveCancelDiscard: boolean,
  } {
    return {
      nameFilterStr: '',
      copiedVw: null,
      draggingTx: null,
      hoveringTx: null,
      draggerBlinking: false,
      showSaveCancelDiscard: false
    }
  },
  computed: {
    vw (): IVW | null { return this.dialog.vw },
    rxList (): IDevice[] {
      if (!this.copiedVw) {return []}
      const vendor = this.copiedVw.vendor
      return this.$s.$state.device.list.filter(x => x.deviceType === 'TX' && x.vendor === vendor)
    },
    filteredRxList (): IDevice[] {
      const filterStr = this.nameFilterStr
      if (!filterStr) { return this.rxList }
      return this.rxList.filter(x => x.deviceName.toLowerCase().includes(filterStr.toLowerCase()))
    }
  },
  methods: {
    async closeThisDialogSafely () {
      this.closeThisDialog()
    },
    preview () {
      // if (!this.copiedVw) {return}
      // easyapi.vwPreviewStart(this.copiedVw)
    },
    closeThisDialogAfterConfirm () {
      if (!this.copiedVw) { console.error('[To Developer] Impossible'); return }
      const vwid = this.copiedVw.id
      const originalVw = this.$s.device.getters.vwList.find(vw => vwid === vw.id)
      if (!originalVw) { console.error('[To Developer] Impossible'); return }
      if (isEqual(this.copiedVw, originalVw)) {
        this.closeThisDialogSafely()
      } else {
        // TODO: onbeforeunload to handle "back" button
        // window.onbeforeunload = function() { return 'Your work will be lost.'; };
        this.showSaveCancelDiscard = true
      }
    },
    getMappedDisplayIndex (mac: string): number {
      if (!this.copiedVw) { return -1 }
      const rx = this.copiedVw.rxList.find(x => x.mac === mac)
      if (!rx) {return -1}
      return rx.displayIndex
    },
    blinkDragger () {
      this.draggerBlinking = true
      setTimeout(() => {
        this.draggerBlinking = false
      }, 1000)
    },
    async save () {
      if (!this.copiedVw) { return }
      const ok = easyapi.modifyVw(this.copiedVw)
      if (ok) {
        this.closeThisDialogSafely()
      }
    },
  },
  watch: {
    'dialog.vw' (nv: IVW|null) {
      if (nv) {
        this.copiedVw = deepCopy(this.dialog.vw)
        this.preview()
      }
    }
  },
  mounted () {
    this.watchElementWidth('vwPreviewContainer', ['vw'])
  }
})
